import type { AgentCostDetail } from '../types/cost';
import type { ScoringValidationResult } from '../types/evaluation';

/** Calculate USD cost from an AgentCostDetail. */
export function calculateAgentCost(cost: AgentCostDetail): number {
  const inputCost = (cost.inputTokens / 1_000_000) * cost.costPerMillionInputTokens;
  const outputCost = (cost.outputTokens / 1_000_000) * cost.costPerMillionOutputTokens;
  return inputCost + outputCost;
}

/** Format a USD amount for display. */
export function formatCost(amount: number): string {
  if (amount < 0.0001) return `$${amount.toFixed(6)}`;
  if (amount < 0.01) return `$${amount.toFixed(4)}`;
  return `$${amount.toFixed(2)}`;
}

/** Sum scoringCost across all results, skipping nulls. */
export function calculateTotalScoringCost(results: ScoringValidationResult[]): number {
  return results.reduce((sum, r) => {
    if (r.scoringCost) {
      return sum + calculateAgentCost(r.scoringCost);
    }
    return sum;
  }, 0);
}

/** Sum token counts across all results, skipping nulls. */
export function calculateTotalTokens(results: ScoringValidationResult[]): { input: number; output: number } {
  return results.reduce(
    (acc, r) => {
      if (r.scoringCost) {
        acc.input += r.scoringCost.inputTokens;
        acc.output += r.scoringCost.outputTokens;
      }
      return acc;
    },
    { input: 0, output: 0 },
  );
}

/** Format token count with K/M suffix. */
export function formatTokenCount(count: number): string {
  if (count >= 1_000_000) return `${(count / 1_000_000).toFixed(1)}M`;
  if (count >= 1_000) return `${(count / 1_000).toFixed(1)}K`;
  return String(count);
}
